<template>
    <div id="titles" class="">
    </div>
</template>

<script>
export default {
  name: 'NovotelRatesHorizontalV2Titles'
}
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../_novotel.scss";

#titles {
  width: 100%;
  @include heightPercent(80);
  text-align: left;
  text-transform: uppercase;
}
</style>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/novotel/rates/horizontal/v2/titles.vue